import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import './select.css';

function Select({
  id = '',
  name = '',
  className = '',
  multiple = false,
  children = [],
  value = undefined,
  maxVisibleItems = 10,
  onChange = undefined,
  onBlur = undefined,
}) {
  const selectRef = useRef(null);

  useEffect(() => {
    window.jcf.replace(selectRef.current);
  }, []);

  useEffect(() => {
    const jcfInstance = window.jcf.getInstance(selectRef.current)?.instance;
    const dropActive = !!(jcfInstance?.dropActive);
    if (!dropActive) {
      window.jcf.refresh(selectRef.current);
    }
  }, [children]);

  return (
    <select
      ref={selectRef}
      id={id}
      name={name}
      className={className}
      multiple={multiple}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      data-jcf={multiple
        ? JSON.stringify({
          wrapNative: false,
          wrapNativeOnMobile: false,
          useCustomScroll: true,
          multipleCompactStyle: true,
          maxVisibleItems,
        })
        : JSON.stringify({
          maxVisibleItems,
        })}
    >
      {children}
    </select>
  );
}

Select.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  multiple: PropTypes.bool,
  maxVisibleItems: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.number),
  ]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export { Select };
